export function FlipVerticalIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fill="currentColor"
        d="M6 4C6 3.63181 5.70152 3.33333 5.33333 3.33333H4.66667C3.5621 3.33333 2.66667 4.22876 2.66667 5.33333V10.6667C2.66667 11.7712 3.5621 12.6667 4.66667 12.6667H5.33333C5.70152 12.6667 6 12.3682 6 12C6 11.6318 5.70152 11.3333 5.33333 11.3333H4.66667C4.29848 11.3333 4 11.0349 4 10.6667V5.33333C4 4.96514 4.29848 4.66667 4.66667 4.66667H5.33333C5.70152 4.66667 6 4.36819 6 4Z"
      />
      <path
        fill="currentColor"
        d="M7.33333 12.6667H11.3333C12.4379 12.6667 13.3333 11.7712 13.3333 10.6667V5.33333C13.3333 4.22876 12.4379 3.33333 11.3333 3.33333H7.33333V4.66667H11.3333C11.7015 4.66667 12 4.96514 12 5.33333V10.6667C12 11.0349 11.7015 11.3333 11.3333 11.3333H7.33333V12.6667Z"
      />
      <path
        fill="currentColor"
        d="M8.66667 13.3333C8.66667 13.7015 8.36819 14 8 14C7.63181 14 7.33334 13.7015 7.33334 13.3333L7.33333 2.66667C7.33333 2.29848 7.63181 2 8 2C8.36819 2 8.66667 2.29848 8.66667 2.66667L8.66667 13.3333Z"
      />
    </svg>
  );
}
